module.exports = __webpack_public_path__ + "img/certificate-CU-4.5-5.5.6072b4a6.jpg";